$(".nav-bar-toggle").click(function (e) {
  $("#partner-nav-bar").toggleClass("header__menu--open");
});
